class scheduleElement {
  constructor(
    elemId,
    name,
    from,
    to,
    inputTol,
    outputTol,
    conceptId,
    conceptName,
    working,
    holidays,
    notHolidays,
    mts,
    fracRed,
    porcen,
    resto,
    nomSegm,
    diasSegm,
  ) {
    function converToHours(item) {
      const horaT = Math.floor(item / 60);
      let minT = Math.floor(horaT * 60);
      minT = item - minT;
      minT = minT < 10 ? "0" + minT : minT;
      if (horaT < 10) {
        return "0" + horaT + ":" + minT;
      } else {
        return horaT + ":" + minT;
      }
    }

    this.elemId = elemId;
    this.name = name;
    this.from = converToHours(from);
    this.to = converToHours(to);
    this.inputTol = converToHours(inputTol);
    this.outputTol = converToHours(outputTol);
    this.conceptId = conceptId;
    this.conceptName = conceptName;
    this.working = working === true ? "✔️" : "";
    this.holidays = holidays === true ? "✔️" : "";
    this.notHolidays = notHolidays === true ? "✔️" : "";
    this.mts = mts;
    this.fracRed = fracRed;
    this.porcen = porcen;
    this.resto = resto;
    this.nomSegm = nomSegm;
    this.diasSegm = diasSegm;
  }
  static fromJson({
    elemId,
    nomElem,
    desde,
    hasta,
    tolEnt,
    tolSal,
    conceptoId,
    nomConcepto,
    laboral,
    aplFeriados,
    aplNoFeriados,
    mts,
    fracRed,
    porcen,
    resto,
    nomSegm,
    diasSegm,
  }) {
    return new scheduleElement(
      elemId,
      nomElem,
      desde,
      hasta,
      tolEnt,
      tolSal,
      conceptoId,
      nomConcepto,
      laboral,
      aplFeriados,
      aplNoFeriados,
      mts,
      fracRed,
      porcen,
      resto,
      nomSegm,
      diasSegm,
    );
  }
}
export default scheduleElement;
